import React, { useEffect, useState } from 'react';
// import Navbar from './Navbar'
import { format } from 'date-fns';

const Home = () => {
  const [curNow, setNow] = useState(null);
  const [refreshInterval, setRefreshInterval] = useState(500000);
  const [data, setData] = useState(null);
  // Home panel
  // auto-refresh
  const refreshHome = () => {
    // update time
    try {
      setNow(format(new Date().toLocaleString(), 'eee HH:mm:ss'));
    } catch (error) {

    }
  }

  useEffect(() => {
    // fetch(`https://ctrl2.cherry2024.com:2096/getservers`)
    //   .then(response => response.json())
    //   .then(data => setData(data))
    //   .catch(error => console.error(error));

    // if (refreshInterval && refreshInterval > 0) {
    //   const interval = setInterval(refreshHome, refreshInterval);
    //   return () => clearInterval(interval);
    // }
  }, );



  return (
    <div className="container topLine3">
        <div className="row">
        <div className="col-sm-12">
          <h1>Home</h1>
          </div>
        </div>
    </div>
  )
}

export default Home;
